import { render, staticRenderFns } from "./RestaurantCell.vue?vue&type=template&id=168406c3&scoped=true&"
import script from "./RestaurantCell.vue?vue&type=script&lang=js&"
export * from "./RestaurantCell.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantCell.vue?vue&type=style&index=0&id=168406c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168406c3",
  null
  
)

export default component.exports